function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

function SvgQuickView(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 17 17"
  }, props), React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, React.createElement("circle", {
    cx: 6.59,
    cy: 6.59,
    r: 6.09,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("path", {
    d: "M6.59,3a3.55,3.55,0,0,1,3.55,3.55",
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), React.createElement("line", {
    x1: 13.19,
    y1: 13.19,
    x2: 16,
    y2: 16,
    style: {
      fill: "none",
      stroke: "#666",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }))));
}

export default __webpack_public_path__ + "static/media/quickView.56a9ca50.svg";
export { SvgQuickView as ReactComponent };